export default __webpack_public_path__ + "static/media/splash.132c3809.png";